import React from "react";
import { Modal } from "@material-ui/core";
import LoadingIndicator from "../commons/LoadingIndicator";

const ModalLoadingIndicator = ({ open = true, hideBackdrop, onClose }) => {
  return (
    <Modal open={open} onClose={onClose} hideBackdrop={hideBackdrop}>
      <div>
        <LoadingIndicator className="modal-loading" />
      </div>
    </Modal>
  );
};

export default ModalLoadingIndicator;
